const DIACRITICS_REGEX = /[̀-ͯ]/g;
const WORD_REGEX = /[a-zA-Z0-9]+/g;

export function deriveVariableKey(label: string): string {
  const normalized = label
    .normalize('NFD')
    .replace(DIACRITICS_REGEX, '')
    .trim();

  const words = normalized.match(WORD_REGEX);

  if (!words || words.length === 0) return '';

  return words
    .map((word, index) =>
      index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join('');
}
